import request from '../request'

export default {
  getImagenesSatelite(data) {
    return request.get(`satelite_imagen/${data.ID_INCENDIO}`)
  },
  getImagenSateliteURL(data) {
    return `${request.defaults.baseURL}/satelite_imagen/${data.API}/${data.ID_INCENDIO}/${data.ESTADO}/${data.NOMBRE_FICHERO}`
  },
  getImagenSatelite(data) {
    return request.get(`satelite_imagen/${data.API}/${data.ID_INCENDIO}/${data.ESTADO}/${data.NOMBRE_FICHERO}`)
  },
  getWFSData(bbox, fromDate, toDate, maxCloudCoverage, priority) {
    return request.get(`satelite_imagen/${bbox}/${fromDate}/${toDate}/${maxCloudCoverage}/${priority}`)
  }
}
